module.exports={
  "Learn More" : "詳細",
  "CLOSED CAPTION PREVIEW": "字幕プレビューを閉じる",
  "Sample Text": "サンプルテキスト",
  "Ad": "広告",
  "Skip Ad": "広告表示をスキップ",
  "LIVE": "ライブ",
  "GO LIVE": "公開開始",
  "CC Options": "字幕オプション",
  "On": "オン",
  "Off": "オフ",
  "Discovery": "検出",
  "Facebook Unavailable": "Facebook を利用できません",
  "Facebook Success": "Facebook でこのビデオを確認してください",
  "Twitter Unavailable": "Twitter を利用できません",
  "Twitter Success": "Twitter でこのビデオを確認してください",
  "Post Title": "投稿成功",
  "Account Configure": "デバイスでアカウントを設定してください",
  "Discover": "検出",
  "Up next": "次回",
  "Video Quality": "ビデオ品質",
  "Share": "共有",
  "Start at": "開始ポイント",
  "Embed": "埋め込み",
  "Email": "メール",
  "Check out this video": "関心があると思われるビデオがあります。確認: ",
  "To": "発行先",
  "Subject": "件名",
  "Message": "メッセージ",
  "name@email.com": "name@email.com",
  "Optional Message": "オプションメッセージ",
  "Send": "送信",
  "RELOAD YOUR SCREEN OR TRY SELECTING A DIFFERENT VIDEO": "画面をリロードするか、別のビデオを選んでください",
  "THIS IS NOT WORKING! :(": "現在これは動作していません! :(",
  "NETWORK ERROR": "ネットワークエラー",
  "Cannot Contact Server": "サーバーと通信できません",
  "SAS ERROR": "SAS エラー",
  "Invalid Authorization Response": "無効な認証応答",
  "SAS GEO ERROR": "SAS GEO エラー",
  "This video is not authorized in your location": "このビデオはユーザーの場所では許可されていません",
  "SAS DOMAIN ERROR": "SAS ドメインエラー",
  "This video is not authorized for your domain": "このビデオはユーザーのドメインでは許可されていません",
  "VIDEO NOT AVAILABLE YET": "ビデオはまだご視聴いただけません",
  "This video will be available soon": "このビデオはすぐに視聴可能になります",
  "VIDEO COMING SOON!": "ビデオ近日公開!",
  "This video is not available yet": "このビデオはまだご視聴いただけません",
  "You may need to refresh the page to access the video after it becomes available" : "ビデオが視聴可能になったら、ページを更新してご視聴ください",
  "VIDEO NO LONGER AVAILABLE": "ビデオはもう視聴いただけません",
  "This video is no longer available": "このビデオはもう視聴いただけません",
  "SAS DEVICE ERROR": "SAS デバイスエラー",
  "This video is not authorized for playback on this device": "このビデオをこのデバイスで再生することは許可されていません",
  "SAS PROXY ERROR": "SAS プロキシエラー",
  "An anonymous proxy was detected. Please disable the proxy and retry.": "匿名プロキシが検出されました。プロキシを無効にして再試行してください。",
  "CONCURRENT STREAMS NUMBER EXCEEDED": "同時アクセスストリームの最大数を超過しました",
  "You have exceeded the maximum number of concurrent streams": "同時アクセスストリームの最大数を超過しました",
  "DEVICE BINDING ERROR": "デバイスバインドエラー",
  "Device binding failed": "デバイスのバインドに失敗しました",
  "DEVICE ID TOO LONG": "デバイス ID が長すぎます",
  "Device ID is too long": "デバイス ID が長すぎます",
  "INVALID PLAYER TOKEN": "無効な Player トークン",
  "Invalid Ooyala Player token": "無効な Ooyaka Player トークン。",
  "AUTHORIZATION ERROR": "認証エラー",
  "Unable to register this device to this account, as the maximum number of authorized devices has already been reached. Error Code 22": "このデバイスをアカウントに登録できません。認証されたデバイスの数が上限に達しています。エラーコード22",
  "Unable to access this content, as the maximum number of devices has already been authorized. Error Code 29": "このコンテンツにアクセスできません。認証されたデバイスの数が上限に達しています。エラーコード29",
  "Please remove one of your authorized devices to enable this device.": "このデバイスを有効にするには、認証されたデバイスのうち1つを削除してください。",
  "LICENSE ERROR": "ライセンスエラー",
  "General error acquiring license": "ライセンス取得での一般的なエラー",
  "DRM SERVER ERROR": "DRMサーバーエラー",
  "DRM server error": "DRMサーバーエラー",
  "INVALID ENTITLEMENTS ERROR": "無効な権利エラー",
  "User Entitlement Terminated - Stream No Longer Active for the User": "ユーザー権利が終了しました - このユーザーのストリームはもう有効ではありません",
  "INVALID HEARTBEAT": "無効なハートビート",
  "Invalid heartbeat response": "無効なハートビート応答",
  "INVALID CONTENT": "無効なコンテンツ",
  "INVALID METADATA": "無効なメタデータ",
  "Invalid Metadata": "無効なメタデータ",
  "PLAYBACK ERROR": "再生エラー",
  "Could not play the content": "コンテンツを再生できませんでした",
  "PLAYBACK STREAM ERROR": "ストリーム再生エラー",
  "This video isn't encoded for your device": "このビデオはお使いのデバイスで再生できるようにエンコードされていません",
  "PLAYBACK LIVESTREAM ERROR": "ライブストリーム再生エラー",
  "Live stream is off air": "ライブストリームはオフになっています",
  "PLAYBACK NETWORK ERROR": "再生ネットワークエラー",
  "Network connection temporarily lost": "ネットワークに一時的に接続できませんでした",
  "UNPLAYABLE CONTENT ERROR": "コンテンツ再生不能エラー",
  "This video is not playable on this player": "このビデオはこのプレイヤーでは再生できません",
  "INVALID EXTERNAL ID": "無効な外部 ID",
  "Invalid External ID": "無効な外部 ID",
  "EMPTY CHANNEL ERROR": "空のチャンネルエラー",
  "This channel is empty": "このチャンネルは空です",
  "EMPTY CHANNEL SET ERROR": "空のチャンネルセットエラー",
  "This channel set is empty": "このチャンネルセットは空です",
  "CHANNEL CONTENT ERROR": "チャンネルコンテンツエラー",
  "This channel is not playable at this time": "このチャンネルは現在再生できません",
  "SOMETHING NOT RIGHT! THERE SHOULD BE VIDEOS HERE.": "エラーがあります!ビデオがあるはずです。",
  "(Try Clicking The Discover Button Again On Reload Your Page)": "(ページをリロードして、[検出] ボタンを再度クリックしてください)",
  "Something happened while we were trying to play your video! Click replay or simply reload your page.": "ビデオを再生するときに何らかのエラーが発生しました![リプレイ] をクリックするか、ページを単にリロードしてください。",
  "Language": "言語",
  "Color Selection": "カラーの選択",
  "Caption Opacity": "字幕の不透明度",
  "Font Type": "フォントタイプ",
  "Font Size": "フォントサイズ",
  "Text Enhancements": "テキストの拡張",
  "Text color": "文字の色",
  "Background color": "背景色",
  "Window color": "ウィンドウの色",
  "Transparent": "透明",
  "White": "白",
  "Blue": "青",
  "Magenta": "マゼンタ",
  "Green": "緑",
  "Yellow": "黄",
  "Red": "赤",
  "Cyan": "シアン",
  "Black": "黒",
  "Text opacity": "テキストの不透明度",
  "Background opacity": "背景の不透明度",
  "Window opacity": "ウィンドウの不透明度",
  "Font size": "フォントサイズ",
  "Small": "小",
  "Medium": "普通",
  "Large": "大",
  "Extra Large": "最大",
  "Text enhancement": "テキストの拡張",
  "Uniform": "均一",
  "Depressed": "くぼみ",
  "Raised": "浮かし",
  "Shadow": "影付き",
  "Play": "再生",
  "Replay": "リプレイ",
  "Pause": "一時停止",
  "Mute": "ミュート",
  "Unmute": "ミュート解除",
  "Closed Captions":"クローズドキャプション",
  "Full Screen": "全画面",
  "Exit Full Screen": "全画面表示を終了",
  "More Options": "その他のオプション",
  "Audio": "オーディオ",
  "Subtitles": "サブタイトル",
  "Undefined language": "未定義の言語",
  "No linguistic content": "言語コンテンツなし",
  "Speed": "速度",
  "Normal": "標準"
}
